// extracted by mini-css-extract-plugin
export default {"message":"_2vKsh","countdown":"_1TpQr","countdown-value":"_2qjau","countdownValue":"_2qjau","countdown-ended":"_3tiO1","countdownEnded":"_3tiO1"};